// @flow

import topic from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Topic';
import newOrExistingAppChild from '../loggedIn/newOrExisting';
import noAppYetChild from '../loggedIn/noAppYet';
import partnershipWithZapier from '../loggedIn/partnerships';

const loggedIn = topic({
  zendeskCustomFieldId: 360044601391,
  label: 'How can we help you?',
  items: [
    {
      value: 'existing',
      icon: 'miscBolt',
      label: 'Help with an existing integration',
      child: newOrExistingAppChild,
      zendeskCustomFieldValue: 'pcf-existing',
    },
    {
      value: 'building',
      icon: 'personCircleFill',
      label: 'Help with a new integration',
      child: noAppYetChild,
      zendeskCustomFieldValue: 'pcf-new',
    },
    {
      value: 'partnership',
      icon: 'formAddSquare',
      label: 'Questions about Partnerships',
      child: partnershipWithZapier,
      zendeskCustomFieldValue: 'pcf-partnerships-platform',
    },
  ],
});

export default loggedIn;
